import React, { useState } from 'react';
import LogoutButton from '../components/LogoutButton';
import TableNavBar from '../components/TableNavBar';
import TableViewer from '../components/TableViewer';
import { tableColumnsConfig } from '../constants/tableColumns';

const Dashboard = () => {
  const [selectedTable, setSelectedTable] = useState('Requests');

  const config = tableColumnsConfig[selectedTable];

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <TableNavBar currentTable={selectedTable} onSelect={setSelectedTable} />

      <div style={{ flex: 1, padding: '2rem', backgroundColor: '#f4f6f8' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h1 style={{
            margin: 0,
            fontSize: '2rem',
            fontWeight: 900,
            color: '#1c1c1c;',
            letterSpacing: '0.5px'
          }}>
            Campus Safety Admin Panel
          </h1>
          <LogoutButton />
        </div>

        {config ? (
          <TableViewer
            prefix={config.prefix}
            tableName={config.endpoint}
            columns={config.columns}
            title={selectedTable}
            filters={config.filters}
            creatable={config.creatable}
            addEndpoint={config.addEndpoint}
            deletable={config.deletable}
            deleteEndpoint={config.deleteEndpoint}
          />
        ) : (
          <p>No configuration found for this table.</p>
        )}
      </div>
    </div>
  );
};

export default Dashboard;


